import { BaseApiService } from './base';
import { API_ENDPOINTS } from '../../config/api';

export interface NotificationItem {
  id: number;
  title: string;
  message?: string;
  type: string;
  link?: string;
  is_read: boolean;
  created_at: string;
}

interface NotificationListResponse {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: NotificationItem[];
}

class NotificationService extends BaseApiService {
  private buildQueryString(params?: Record<string, any>): string {
    if (!params) return '';
    const query = Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
      .join('&');
    return query ? `?${query}` : '';
  }

  async getNotifications(params?: { is_read?: boolean; page?: number }): Promise<{ items: NotificationItem[]; count: number }> {
    const query = this.buildQueryString({
      is_read: params?.is_read,
      page: params?.page,
    });
    const data = await this.request<NotificationListResponse | NotificationItem[]>(`${API_ENDPOINTS.NOTIFICATIONS}${query}`);

    if (Array.isArray(data)) {
      return { items: data, count: data.length };
    }

    const items = data.results || [];
    return {
      items,
      count: data.count ?? items.length,
    };
  }

  async getUnreadCount(): Promise<number> {
    const data = await this.request<{ count: number }>(API_ENDPOINTS.NOTIFICATIONS_UNREAD_COUNT);
    return data.count || 0;
  }

  async markRead(ids: number[]): Promise<number> {
    const data = await this.request<{ updated: number }>(API_ENDPOINTS.NOTIFICATIONS_MARK_READ, {
      method: 'POST',
      body: JSON.stringify({ ids }),
    });
    return data.updated || 0;
  }

  async markAllRead(): Promise<number> {
    const data = await this.request<{ updated: number }>(API_ENDPOINTS.NOTIFICATIONS_MARK_ALL_READ, {
      method: 'POST',
    });
    return data.updated || 0;
  }
}

export const notificationService = new NotificationService();
